import React, {useMemo} from 'react';
import moment from 'moment';

export default ({
  item,
  calculatePositionOfStickyHeaders,
  config,
  config: {prop = 'lastLoginAt'},
  index,
}) => {
  const lastLogin = useMemo(
    () =>
      item.lastLoginAt ? moment(item[prop]).format('YYYY-MM-DD hh:mm') : '-',
    [item.lastLoginAt]
  );

  return (
    <td
      className={`text-center ${index === 0 ? 'first-cell' : ''}`}
      style={calculatePositionOfStickyHeaders(config)}
    >
      {lastLogin}
    </td>
  );
};
